
$( document ).ready(function() {
$('.coqproducta #ProductSelect-coqoz1b-option-0>div:first-child label').html('3 Pack<br/><em>(for 1x daily)</em>');
$('.coqproducta #ProductSelect-coqoz1b-option-0>div:last-child label').html('6 Pack<br/><em>(for 2x daily)</em>');
$('.coqproducta #ProductSelect-coqoz1b-option-0>div:last-child').append('<span class="nfs-best-saving">Best Value</span>');
});

$(document).ready(function(){
setTimeout(function(){
      //       $('.rc_label__onetime').html('One-time purchase: <b>$54.00</b>');
      $('.coqproducta #AddToCartForm-coqoz1b .sub_percent').text('(40%)');
      $('.coqproducta #AddToCartForm-coqoz1b .sub_price').text('$54.00');
      $('.coqproducta #AddToCartForm-coqoz1b .sub_percent').attr("id","subpercent");
  $('.coqproducta #AddToCartForm-coqoz2b .sub_percent').attr("id","subpercent");
      $('.coqproducta .sub_percent').removeAttr('id');
      $('.coqproducta #AddToCartForm-coqoz1b .sub_price').removeAttr("data-rtx-subscription-price");
      $('.coqproducta #AddToCartForm-coqoz1b .rtx_strike').removeAttr("data-rtx-onetime-price");
      
      //  $('#AddToCartForm-coqoz1b .rtx-subscription>div>label:first-child .sub_price').after('<div class="rtxshotsubprice"></div>');
      //  $('#AddToCartForm-coqoz1b .rtx-subscription>div>label:last-child #one_time_price').after('<div class="rtx-shot-one-price"></div>');
      
      $('.coqproducta #AddToCartForm-coqoz1b .rtx-subscription-label .rtxshotsubprice').text('($2.25 per Dose shot)');
      $('.coqproducta #AddToCartForm-coqoz1b .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('.coqproducta #AddToCartForm-coqoz2b .rtx-subscription-label .rtxshotsubprice').removeClass('rtx-shot-sub-price');
      $('.coqproducta #AddToCartForm-coqoz1b .onetime .rtx-shot-one-price').text('($3.75 per Dose shot)');
      $('.coqproducta #AddToCartForm-coqoz2b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('.coqproducta #AddToCartForm-coqoz2b .rtx-subscription>div>label:last-child .onetime .rtxshotsubprice').text('($4.13 per Dose shot)');

 
}, 300);

});
$(document).ready(function(){
setTimeout(function(){
$('.coqproducta .rc_label__deliver_every').after('<p class="nfs-nocomitment">No commitment, cancel anytime</p>');
}, 300);

});

$(".coqproducta #ProductSelect-coqoz1b-option-0>div:first-child").click(function() {
$('.coqproducta #purchaseTypeSubscription-7697614143729---AddToCartForm-coqoz1b').click();
$('.coqproducta .rtx-subscription>div>label:first-child').click();
setTimeout(function(){     
$('.coqproducta #AddToCartForm-coqoz1b .sub_percent').text('(40%)');
$('.coqproducta #AddToCartForm-coqoz1b .sub_price').text('$54.00');
$('.coqproducta .sub_price').removeAttr("data-rtx-subscription-price");
$('.coqproducta #AddToCartForm-coqoz1b .rtx_strike').text('$54.00');
$('.coqproducta #AddToCartForm-coqoz1b .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('.coqproducta #AddToCartForm-coqoz1b .rtx-subscription-label .rtxshotsubprice').text('($2.25 per Dose shot)');
  
$('.coqproducta #AddToCartForm-coqoz1b .onetime .rtx-shot-one-price').text('($3.75 per Dose shot)');
}, 300);
});    

$(".coqproducta #ProductSelect-coqoz1b-option-0>div:last-child").click(function() {
$('.coqproducta #purchaseTypeSubscription-7697614143729---AddToCartForm-coqoz1b').click();
$('.coqproducta .rtx-subscription>div>label:first-child').click();
setTimeout(function(){     
$('.coqproducta #AddToCartForm-coqoz1b .sub_percent').text('(40%)');
$('.coqproducta #AddToCartForm-coqoz1b .sub_price').text('$96.00');
$('.coqproducta .sub_price').removeAttr("data-rtx-subscription-price");
$('.coqproducta #AddToCartForm-coqoz1b .rtx_strike').text('$160.00');
$('.coqproducta #AddToCartForm-coqoz1b .rtx_strike').removeAttr("data-rtx-onetime-price");
  $('.coqproducta #AddToCartForm-coqoz1b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.00 per Dose shot)');
$('.coqproducta #AddToCartForm-coqoz1b .onetime .rtx-shot-one-price').text('($3.33 per Dose shot)');


}, 300);
});




jQuery('.oztaba>span:first-child').click(function() {
    $(this).addClass('active');
    $('.oztaba>span:last-child').removeClass('active');
    $('.coqproducta #AddToCartForm-coqoz1b').show();
    $('.coqproducta #AddToCartForm-coqoz2b').hide();
 
      $('.coqproducta .edumrp').text('$54.00');
    $('.coqproducta .edusp').text('$54.00');
  
  $('.coqproducta .main-pr1').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/cholesterolImage1.png?v=1739891938");
    $('.coqproducta .main-pr11').attr("src", "https://cdn.shopify.com/s/files/1/0348/3317/0477/files/cholesterolImage1.png?v=1739891938");

  });

jQuery('.oztaba>span:last-child').click(function() {
      $(this).addClass('active');
      $('.oztaba>span:first-child').removeClass('active');
      $('.coqproducta #AddToCartForm-coqoz1b').hide();
      $('.coqproducta #AddToCartForm-coqoz2b').show();
      $('.coqproducta #AddToCartForm-coqoz2b .sub_percent').text('(40%)');
      $('.coqproducta #AddToCartForm-coqoz2b .sub_price').text('$59.40');
   $('.coqproducta #AddToCartForm-coqoz2b .sub_price').removeAttr("data-rtx-subscription-price");
      $('.coqproducta #AddToCartForm-coqoz2b .rtx_strike').removeAttr("data-rtx-onetime-price");
     
      $('.coqproducta #AddToCartForm-coqoz2b .sub_price').removeClass('sub_price');
      $('.coqproducta #AddToCartForm-coqoz2b .rtx-subscription>div>label:first-child .rtxshotsubprice').text('($2.88 per Dose shot)');
      $('.coqproducta #AddToCartForm-coqoz2b .rtx-subscription>div>label:first-child .rtxshotsubprice').removeClass('rtx-shot-one-price');;
      
      $('.coqproducta #AddToCartForm-coqoz2b .rtx-subscription>div>label:last-child .rtx-shot-one-price').text('($4.13 per Dose shot)');
      $('.coqproducta .edumrp').text('$99.00');
      $('.coqproducta .edusp').text('$59.40');
  $('.coqproducta .main-pr1').attr("src", "https://dosedaily.co/cdn/shop/files/5_8e411cdb-0f35-4683-95f7-15342fa6b664_1800x1800.png?v=1729108402");
     $('.coqproducta .main-pr11').attr("src", "https://dosedaily.co/cdn/shop/files/5_8e411cdb-0f35-4683-95f7-15342fa6b664_1800x1800.png?v=1729108402");

});






 



jQuery('.coqproducta .pr-img1 img').click(function() {
var thissrc = jQuery(this).attr('src');
jQuery('.coqproducta .main-pr1').attr('src', thissrc);
jQuery('.coqproducta .pr-img1 img').removeClass('activepr');
jQuery(this).addClass('activepr');
});


$(document).ready(function(){
setTimeout(function(){
$('.nfs-nocomitment').html('<ul><li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>Save 15% on recurring orders</span></li></li> <li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>No commitments! Adjust or cancel anytime</span></li> <li><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="11.1548" cy="11.1548" r="11.1265" fill="#57665C" stroke="#FDF4E7" stroke-width="0.0567677"/> <path d="M6.8125 12.8295L9.82119 15.7247L15.5263 6.58508" stroke="#FDF4E7" stroke-width="1.41919" stroke-linecap="round"/> </svg><span>30-Day Money-back Guarantee**</span></li></ul>');
}, 2000);
});



$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 50
    }, 500);
});

$(".coq-boxdmaa").click(function() {
  $(this).toggleClass('flipcardliveri');
$(this).children('.coq-boxdmab').toggleClass('flipcardliver');
});


           